module.exports = __webpack_public_path__ + "img/citbank.3e6ae97d.png";